import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../../../../../../../lib/esm/components';
import { ButtonsWrapper, ContentWrapper, Wrapper } from './styles/styles';
import './styles/styles.scss';

interface IProps {
    /** Закрытие модалки с подтверджением удаления */
    closeModal: () => void;

    /** Уделение*/
    onDelete: () => void;
}

/**
 * Компонент для подтверждения удаления типа события
 */
const DeleteConfirmModalBody: FC<IProps> = ({ closeModal, onDelete }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <ContentWrapper>
                <div>{t('You are going to delete the event type. Continue?')}</div>
            </ContentWrapper>
            <ButtonsWrapper>
                <Button onClick={closeModal} addClasses={'margin-left'} theme="outline">
                    {t('Cancel')}
                </Button>
                <Button onClick={onDelete} addClasses={'margin-left'}>
                    {t('Ok')}
                </Button>
            </ButtonsWrapper>
        </Wrapper>
    );
};

export default DeleteConfirmModalBody;
